export default {
  getRecordComments: (state) => (recordId) => {
    return filterComments(state.comments, comment => comment.record === recordId);
  },
  getUserComments: (state) => (userId) => {
    return filterComments(state.comments, comment => comment.user === userId);
  },
  getAllComments: (state) => () => {
    return filterComments(state.comments);
  }
}

function filterComments(comments = {}, filter) {
  const items = [];
  const mapItems = {};
  for (let key in comments) {
    if (!filter || filter(comments[key])) {
      const comment = {...comments[key]};
      comment.date = new Date(comment.date);
      mapItems[comment.id] = comment;
      items.push(comment);
    }
  }

  const filterItmes = items
    .sort((a, b) => a.date - b.date)
    .reduce((parentComments, comment) => {
      const parent = comment.parent && mapItems[comment.parent];
      if (!parent) {
        parentComments.push(comment);
      } else {
        if (!parent.children) {
          parent.children = []
        }
        parent.children.push(comment);
      }
      return parentComments;
    }, []);

    return filterItmes;
}
